import { render, staticRenderFns } from "./CreateProperty.yaml?vue&type=template&id=33feca3c&component"
import script from "./CreateProperty.yaml?vue&type=script&lang=ts&component"
export * from "./CreateProperty.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports